import clsx from "clsx";

import { EmptyDataDash, PingIcons, Text } from "@/components";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { useTaggableUsers } from "@/contexts/TaggableUsersContext";
import { dates } from "@/lib/dates";
import { LastPing, PingType } from "@/types";

export const LastPingCell = ({ lastPing }: { lastPing: LastPing | null }) => {
  const { userNameMap } = useTaggableUsers();

  if (!lastPing) {
    return <EmptyDataDash />;
  }

  const stafferName = userNameMap[lastPing.stafferId] ?? "Unknown staffer";
  const hoursAgo = dates.calculateHoursAgo(lastPing.at);
  const daysAgo = dates.calculateDaysAgo(lastPing.at);
  const timeAgo = dates.timeAgoForPipeline(lastPing.at);
  const recencyColor = clsx(
    hoursAgo < 24
      ? "text-green-700"
      : daysAgo < 3
        ? "text-slate-700"
        : daysAgo < 7
          ? "text-yellow-600"
          : "text-red-900",
  );

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex w-fit items-center gap-2">
            <PingIcons lastPing={lastPing} />
            <span className={recencyColor}>{timeAgo}</span>
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-xs">
          <Text className="text-xs">{stafferName}</Text>
          <Text className="text-xs text-slate-400">
            {dates.formatExactDate(lastPing.at)}
          </Text>
          {lastPing.type === PingType.MESSAGE && lastPing.body && (
            <Text className="mt-1 whitespace-pre-wrap text-xs italic">
              “{lastPing.body}”
            </Text>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
